module.exports = __webpack_public_path__ + "static/phone-slide-1-dab69beaeca7e51280bc2ab43e1b5a9e.png";